import React from 'react';
import PropTypes from 'prop-types';
import RightPaneContentTabs from '../right-pane/right-pane-content-tabs';

export const DomainDetailsContentTabs = ( { handleTabChange, tabIndex } ) => {
    const tabData = [
        {
            dataAutomationId: 'domain-details-senders-tab',
            label: 'Senders',
        },
        {
            dataAutomationId: 'domain-details-dns-tab',
            label: 'DNS',
        },
        {
            dataAutomationId: 'domain-details-general-tab',
            label: 'General',
        }
    ];

    return (
        <RightPaneContentTabs
            handleTabChange={handleTabChange}
            tabData={tabData}
            tabIndex={tabIndex}
        />
    );
};

DomainDetailsContentTabs.propTypes = {
    handleTabChange: PropTypes.func.isRequired,
    tabIndex: PropTypes.number.isRequired
};

export default DomainDetailsContentTabs;
